import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

/* ─── Styled components ──────────────────────────────────────── */

const HeaderRoot = styled("div")(({ theme }) => ({
  height: theme.layout.headerHeight,
  width: "100%",
  backgroundColor: theme.palette.common.white,
  display: "flex",
  alignItems: "center",
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
}));

const HeaderSection = styled("div")({
  flex: 1,
  display: "flex",
  alignItems: "center",
});

const CenterSection = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const RightSection = styled("div")({
  flex: 1,
  display: "flex",
  justifyContent: "flex-end",
});

const GoBackButton = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
  cursor: "pointer",
  color: theme.palette.text.primary,
  "&:hover": { opacity: 0.7 },
}));

const GoBackLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.md,
  fontWeight: 500,
}));

const HeaderTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.headerTitle,
}));

const HeaderSubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.headerSubtitle,
  color: theme.palette.text.secondary,
}));

/* ─── Component ──────────────────────────────────────────────── */

export default function CVHeader({ menuItems }) {
  const navigate = useNavigate();

  return (
    <HeaderRoot>
      <HeaderSection>
        <GoBackButton onClick={() => navigate(-1)}>
          <ArrowBackIcon fontSize="small" />
          <GoBackLabel>Go Back</GoBackLabel>
        </GoBackButton>
      </HeaderSection>

      <CenterSection>
        <HeaderTitle component="h1">CV Builder</HeaderTitle>
        <HeaderSubtitle>Create a professional CV in minutes.</HeaderSubtitle>
      </CenterSection>

      <RightSection>{menuItems}</RightSection>
    </HeaderRoot>
  );
}

CVHeader.propTypes = {
  menuItems: PropTypes.element.isRequired,
};
